namespace GeniuzPOS.Lookups {
    export interface CusProductTypeNbpRow {
        CusProductTypeNbp?: string;
        NbpName?: string;
    }

    export namespace CusProductTypeNbpRow {
        export const idProperty = 'CusProductTypeNbp';
        export const nameProperty = 'NbpName';
        export const localTextPrefix = 'Lookups.CusProductTypeNbp';
        export const lookupKey = 'Lookups.CusProductTypeNbp';

        export function getLookup(): Q.Lookup<CusProductTypeNbpRow> {
            return Q.getLookup<CusProductTypeNbpRow>('Lookups.CusProductTypeNbp');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CusProductTypeNbp = "CusProductTypeNbp",
            NbpName = "NbpName"
        }
    }
}
